import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import CompanyIncomingInvoices from "./companyIncomingInvoices";
import CompanyOutgoingInvoices from "./companyOutgoingInvoices";
import AdminDashboard from "./admindashboard";
import "./hm-theme.css";

function CompanyInvoicesTab({ selectedOrgcode }) {
  const [activeTab, setActiveTab] = useState("incomingInvoices");
  let companycode = selectedOrgcode || JSON.parse(localStorage.getItem("data"))?.orgcode || "";
  const userRole = JSON.parse(localStorage.getItem("data"))?.role; 

  return (
    <>
      {userRole === "ROLE_EMPLOYER" && <AdminDashboard />}
      
      <div className={`col-12 mx-xl-auto ${userRole === "ROLE_EMPLOYER" ? "ps-xl-10 mt-10" : ""}`}>
        <div className="hm-card hm-tabs">
          <div className="hm-card-body p-4">
            <Tabs
              id="invoices-tabs"
              activeKey={activeTab}
              onSelect={(tab) => setActiveTab(tab)}
              className="mb-4"
            >
              <Tab
                eventKey="incomingInvoices"
                title={
                  <span className="d-inline-flex align-items-center gap-1">
                    <i className="material-icons" style={{ fontSize: "1.1rem" }}>call_received</i>
                    Incoming Invoices
                  </span>
                }
              >
                {activeTab === 'incomingInvoices' && <CompanyIncomingInvoices selectedOrgcode={companycode} />}
              </Tab>
              <Tab
                eventKey="outgoingInvoices"
                title={
                  <span className="d-inline-flex align-items-center gap-1">
                    <i className="material-icons" style={{ fontSize: "1.1rem" }}>call_made</i>
                    Outgoing Invoices
                  </span>
                }
              >
                {activeTab === 'outgoingInvoices' && <CompanyOutgoingInvoices selectedOrgcode={companycode} />}
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    </>
  );
}

export default CompanyInvoicesTab;

